import { Spin } from 'antd'
import React from 'react'
import styled from 'styled-components';

const Loader = () => {
    return (
        <LoaderWrapper>
            <Spin size="large" />
        </LoaderWrapper>
    )
}

export default Loader;

const LoaderWrapper = styled.div`
    height: 100vh;
    display:flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: fixed;
    top: 0px;
    background: #ffffff94;
    z-index: 999;
`;